import React from 'react'
import { Table, Icon, Button, Input, Form, Popup, Checkbox, Label } from 'semantic-ui-react'
import TextareaAutoSize from 'react-textarea-autosize'
import styled from 'styled-components'
import _ from 'lodash'

const ItemOptionWrapper = styled.div`
  margin-bottom: 10px;
`

const ItemOptionTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: gray;
  padding: 5px 10px;
  border-radius: 5px;
  margin-bottom: 10px;
`

const ItemOptionTitle = styled.p`
  color: white;
  margin-bottom: 0;
`

const ChoiceWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`

const ItemCell = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
`

const removeReasons = [
  {
    title: 'Out of Stock',
    value: 'out_of_stock',
    color: 'black',
  },
  {
    title: 'Customer Adjusts',
    value: 'customer_adjusts',
  },
  {
    title: 'Other',
    value: 'other',
  }
]

export default class EditItemRow extends React.PureComponent {
  renderCustomable = (item, itemKey) => {
    const { saving, nameChange } = this.props

    const itemCode = item.code ? `-${item.code}` : ''
    const itemNameWithCode = `${item.name} ${itemCode}`

    if (item.customable) {
      return (
        <Input
          name={itemKey}
          value={item.name}
          onChange={nameChange}
          type="text"
          disabled={saving}
        />
      )
    }

    return itemNameWithCode || item.data.name || '...'
  }

  renderItemOption = (option, optionKey) => {
    const { itemOptions = {}, item, onItemOptionClick } = this.props
    const itemOption = itemOptions[optionKey]

    if (!itemOption) return null

    return (
      <ItemOptionWrapper key={optionKey}>
        <ItemOptionTitleWrapper>
          <ItemOptionTitle>
            {itemOption.name}
            {itemOption.is_required && <span style={{ color: 'red', marginLeft:3 }}>*</span>}
          </ItemOptionTitle>
          <ItemOptionTitle>
            { itemOption.is_multiple && `Maximum: ${itemOption.max_choice}` }
          </ItemOptionTitle>
        </ItemOptionTitleWrapper>
        {
          _.map(option.choices, (choice, choiceKey) => {
            const choiceName = _.get(itemOption, ['choices', choiceKey, 'name'])
            const selectedChoice = _.get(item, ['options', optionKey, 'selected_choices', choiceKey], {})
            const checked = _.size(selectedChoice) > 0

            return (
              <ChoiceWrapper key={choiceKey}>
                <Checkbox
                  label={choiceName}
                  onChange={() => onItemOptionClick(optionKey, choiceKey)}
                  checked={checked}
                />
                <div>+ {parseFloat(choice.price).toFixed(2)}$</div>
              </ChoiceWrapper>
            )
          })
        }
      </ItemOptionWrapper>
    )
  }

  renderProductOptionPopUp = item => {
    const { merchantItems = {}, loading } = this.props
    const merchantItem = merchantItems[item.item_key]

    if (!merchantItem || !merchantItem.options) return <div />

    return (
      <Popup
        trigger={<Icon name='clipboard check' size='large' />}
        hideOnScroll
        flowing
        hoverable
        position="right center"
      >
        <div style={{ width: 300, maxHeight: 300, overflowY: 'auto', paddingRight: 10 }}>
          { loading ? 'Loading...' : _.map(merchantItem.options, this.renderItemOption) }
        </div>
      </Popup>
    )
  }

  renderRemoveOptions = () => {
    const { removeItem } = this.props

    return removeReasons.map(reason => (
      <div style={{ marginBottom: 3 }} key={reason.value}>
        <Button size="tiny" color={reason.color} fluid onClick={() => removeItem(reason.value)}>
          {reason.title}
        </Button>
      </div>
    ))
  }

  render() {
    const {
      item,
      itemKey,
      saving,
      increaseQty,
      decreaseQty,
      priceChange,
      specialNoteChange,
    } = this.props

    return (
      <Table.Row>
        <Table.Cell collapsing>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Popup
              on="click"
              position="bottom center"
              trigger={
                <Button
                  size='mini'
                  color="red"
                  icon="remove circle"
                  labelPosition="right"
                  content="Remove item"
                />
              }
            >
              {this.renderRemoveOptions()}
            </Popup>
          </div>
        </Table.Cell>
        <Table.Cell>
          <ItemCell>
            {this.renderCustomable(item, itemKey)}
            {this.renderProductOptionPopUp(item, itemKey)}
          </ItemCell>
          {
            _.map(item.options, option => (
              _.map(option.selected_choices, choice => (
                <div style={{ marginBottom: 2 }} key={choice.name}>
                  <Label size="small">
                    {option.option_name}: {choice.name} (+ {parseFloat(choice.price).toFixed(2)}$)
                  </Label>
                </div>
              ))
            ))
          }

        </Table.Cell>
        <Table.Cell textAlign="center" collapsing>
          <Button.Group>
            <Button disabled={saving} color="black" onClick={decreaseQty}>
              -
            </Button>
            <Button>{item.quantity}</Button>
            <Button disabled={saving} color="black" onClick={increaseQty}>
              +
            </Button>
          </Button.Group>
        </Table.Cell>
        <Table.Cell textAlign="center" collapsing>
          <Input
            name="price"
            value={item.price_at_order}
            onChange={priceChange}
            type="number"
            step={0.01}
            disabled={saving}
          />
        </Table.Cell>
        <Table.Cell>
          <Form>
            <TextareaAutoSize
              placeholder="Special note..."
              rows={1}
              minRows={1}
              onChange={specialNoteChange}
              value={item.special_note || ''}
              disabled={saving}
            />
          </Form>
        </Table.Cell>
      </Table.Row>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/orders/EditItemRow.js